// extracted by mini-css-extract-plugin
export var left = "dualText-module--left--25299";
export var right = "dualText-module--right--08ee1";
export var wrapper = "dualText-module--wrapper--eab12";